import _ from 'lodash'

var DisplayFormError = {
  data() {
    return {
      errors: {},
    }
  },
  methods: {
    showErrors() {
      if(_.keys(this.errors).length > 0) {
        this.$nextTick(function () {
          var errorMessages = document.getElementsByClassName('error-message');
          if(errorMessages.length > 0) {
            errorMessages[0].scrollIntoView({block: "center", inline: "nearest", behavior: 'smooth' });
          }
        });
      }
    },
  },
}

export default DisplayFormError;
